import React from 'react';

interface HeroProps {
  onStart?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onStart }) => {
  return (
    <section className="relative overflow-hidden bg-slate-950 text-white py-20 lg:py-32">

      {/* VIBE BACKGROUND: Active Scan Hero */}
      <div className="absolute inset-0 z-0">
        <img
          src="/workspace/assets/vibe/001_the_active_scan_hero.jpeg"
          alt="Active Scan Background"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-slate-950/80 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs font-mono mb-6 backdrop-blur-sm animate-pulse">
          <span className="w-2 h-2 rounded-full bg-blue-500"></span>
          MISSION // EMPOWER YOUR DIGITAL HERITAGE
        </div>

        <h1 className="text-5xl lg:text-7xl font-bold tracking-tight mb-6">
          Uncover the true <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">Story.</span>
        </h1>

        <p className="text-lg text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed">
          From restoring the lost magic of vintage sports cards, to reviving authentic human writing, to breathing life into your cherished game ideas. SlabLogic connects these diverse tools under a single human-centric mission: <span className="text-slate-200 font-semibold">Elevating human creativity and uncovering truth.</span>
        </p>
      </div>
    </section>
  );
};

export default Hero;